export default "__VITE_ASSET__94f42870__"